import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private loading$ = new BehaviorSubject<boolean>(false);
  public isLoading = this.loading$.asObservable();
  private spinnerCount = 0;

  /**
   *  Increments the spinner count and shows the spinner if it is not already visible.
   *
   * @memberof SpinnerService
   */
  public showSpinner() {
    this.spinnerCount++;
    if (this.spinnerCount > 0) {
      this.loading$.next(true);
    }
  }

  /**
   * Decrements the spinner count and hides the spinner if the count reaches zero.
   *
   * @memberof SpinnerService
   */
  public hideSpinner() {
    this.spinnerCount--;
    if (this.spinnerCount <= 0) {
      this.spinnerCount = 0;
      this.loading$.next(false);
    }
  }
}
